"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/styles");
var LabelWithTooltipComponent_1 = __importDefault(require("../../../shared/components/MessageComponents/LabelWithTooltipComponent"));
var TooltipComponent_1 = __importDefault(require("../../../shared/components/MessageComponents/TooltipComponent"));
var react_redux_1 = require("react-redux");
var crude_selector_1 = require("../../../store/crude/crude.selector");
var DialogComponent_1 = __importDefault(require("../../../shared/components/MessageComponents/DialogComponent"));
var Search_1 = __importDefault(require("@mui/icons-material/Search"));
var messageTypes_1 = require("../../../shared/types/messageTypes");
var useStyles = styles_1.makeStyles(function (theme) { return ({
    table: {
        '& .MuiTableCell-root': {
            borderBottom: 'none',
        },
    },
}); });
var CrudeEnumSelection = function (props) {
    var _a;
    var t = react_i18next_1.useTranslation().t;
    var classes = useStyles();
    var appLayout = react_redux_1.useSelector(crude_selector_1.getAppLayout);
    var theme = react_redux_1.useSelector(crude_selector_1.getTheme);
    var tableRef = react_1.useRef(null);
    var _b = react_1.useState(appLayout.maxRowsPerDialogPage || 15), rowsPerPage = _b[0], setRowsPerPage = _b[1];
    var _c = react_1.useState(props.options), options = _c[0], setOptions = _c[1];
    var _d = react_1.useState(null), value = _d[0], setValue = _d[1];
    var _e = react_1.useState(0), page = _e[0], setPage = _e[1];
    react_1.useEffect(function () {
        appLayout.maxRowsPerDialogPage && setRowsPerPage(appLayout.maxRowsPerDialogPage);
    }, [appLayout.maxRowsPerDialogPage]);
    react_1.useEffect(function () {
        props.options && setOptions(props.options);
    }, [props.options]);
    react_1.useEffect(function () {
        props.value ? setValue(props.value) : setValue(null);
    }, [props.value]);
    var handleChangePage = function (e, page) {
        setPage(page);
    };
    var changeSearchInput = function (searchInput) {
        var regExp = new RegExp((searchInput || '').replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'), 'i');
        var filteredOptions = [];
        props.options && props.options.map(function (element) {
            if (element.value.match(regExp)) {
                filteredOptions.push(element);
            }
        });
        setOptions(filteredOptions);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, options &&
        react_1.default.createElement(DialogComponent_1.default, { open: true, request: true, severity: messageTypes_1.Severity.info, onClose: function () { return props.onClose && props.onClose(); }, cancelLabel: t('crude:close'), confirmLabel: null, autoClose: false, onCancel: function () { return props.onClose && props.onClose(); }, content: react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(material_1.Box, { sx: { mb: 2, mt: 1 } },
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                        react_1.default.createElement(material_1.TextField, { id: 'search', autoFocus: true, label: t('crude:search'), name: 'name', color: 'primary', autoComplete: 'off', sx: {
                                pr: 2,
                                width: '100%',
                                '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                                    borderColor: theme.palette.primary.main,
                                    borderWidth: 2,
                                },
                            }, InputProps: {
                                endAdornment: (react_1.default.createElement(material_1.InputAdornment, { position: 'end' },
                                    react_1.default.createElement(Search_1.default, null))),
                            }, InputLabelProps: {
                                shrink: true,
                            }, onChange: (function (event) {
                                changeSearchInput(event.target.value);
                            }), size: 'small', variant: (_a = appLayout.textfield) === null || _a === void 0 ? void 0 : _a.type }))),
                react_1.default.createElement(material_1.Box, { sx: { mt: 2 } },
                    react_1.default.createElement(material_1.TableContainer, null,
                        react_1.default.createElement(material_1.Table, { size: 'small', className: classes.table, ref: tableRef },
                            react_1.default.createElement(material_1.TableBody, null, options.map(function (option, index) {
                                var minIndex = page * rowsPerPage;
                                var maxIndex = minIndex + rowsPerPage - 1;
                                if (index <= maxIndex && index >= minIndex) {
                                    var fontWeight = option === value ? 'bold' : 'normal';
                                    var element = react_1.default.createElement("span", null, option.value);
                                    return (react_1.default.createElement(material_1.TableRow, { key: "EnumSelectionTableRow" + index },
                                        react_1.default.createElement(material_1.TableCell, { style: { cursor: 'pointer', fontWeight: fontWeight }, onClick: function () { return props.onChange && props.onChange(option); }, key: "EnumSelectionTableCell" + index, children: react_1.default.createElement(react_1.default.Fragment, null, option.description
                                                ? (react_1.default.createElement(TooltipComponent_1.default, { title: option.description, placement: 'right', element: element }))
                                                : react_1.default.createElement(react_1.default.Fragment, null, element)) })));
                                }
                            })))),
                    (options && (options.length > rowsPerPage)) &&
                        react_1.default.createElement(material_1.TablePagination, { component: 'div', count: options && options.length, rowsPerPageOptions: [], rowsPerPage: rowsPerPage, page: page, backIconButtonProps: {
                                'aria-label': "" + t('crude:lastPage'),
                            }, nextIconButtonProps: {
                                'aria-label': "" + t('crude:nextPage'),
                            }, onPageChange: handleChangePage }))), title: react_1.default.createElement(LabelWithTooltipComponent_1.default, { label: props.label, description: props.description }) })));
};
exports.default = CrudeEnumSelection;
